"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePrezlyMetaPlugin = void 0;
var version_1 = require("../version");
/**
 * This plugin is complementing the Prezly Meta injection logic in the `useAnalytics` hook.
 * It moves the `prezly` object from event properties to the event root.,
 */
function normalizePrezlyMetaPlugin() {
    function applyEvent(ctx) {
        var properties = ctx.event.properties;
        if (!properties || !properties.prezly) {
            return ctx;
        }
        var prezlyMeta = properties.prezly, normalizedProperties = __rest(properties, ["prezly"]);
        ctx.updateEvent('prezly', prezlyMeta);
        ctx.updateEvent('properties', normalizedProperties);
        return ctx;
    }
    function applyIdentify(ctx) {
        var traits = ctx.event.traits;
        if (!traits || !traits.prezly) {
            return ctx;
        }
        var prezlyMeta = traits.prezly, normalizedTraits = __rest(traits, ["prezly"]);
        ctx.updateEvent('prezly', prezlyMeta);
        ctx.updateEvent('traits', normalizedTraits);
        return ctx;
    }
    return {
        name: 'Normalize Prezly Meta',
        type: 'enrichment',
        version: version_1.version,
        isLoaded: function () { return true; },
        load: function () { return Promise.resolve(); },
        identify: applyIdentify,
        page: applyEvent,
        track: applyEvent,
    };
}
exports.normalizePrezlyMetaPlugin = normalizePrezlyMetaPlugin;
//# sourceMappingURL=normalizePrezlyMeta.js.map